// Export clients to CSV
export const exportClientsToCSV = (clients) => {
  if (!clients || clients.length === 0) {
    throw new Error('No clients to export');
  }

  // Define CSV headers
  const headers = [
    'Name',
    'Email',
    'Phone',
    'Address',
    'City',
    'State',
    'ZIP',
    'Source',
    'Notes',
  ];

  // Convert clients to CSV rows
  const rows = clients.map(client => [
    escapeCSV(client.name || ''),
    escapeCSV(client.email || ''),
    escapeCSV(client.phone || ''),
    escapeCSV(client.address || ''),
    escapeCSV(client.city || ''),
    escapeCSV(client.state || ''),
    escapeCSV(client.zip || ''),
    escapeCSV(client.source || ''),
    escapeCSV(client.notes || ''),
  ]);

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `clients_export_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Export clients to JSON
export const exportClientsToJSON = (clients) => {
  if (!clients || clients.length === 0) {
    throw new Error('No clients to export');
  }

  // Remove internal fields and format for export
  const exportData = clients.map(client => ({
    name: client.name || '',
    email: client.email || '',
    phone: client.phone || '',
    address: client.address || '',
    city: client.city || '',
    state: client.state || '',
    zip: client.zip || '',
    source: client.source || '',
    notes: client.notes || '',
  }));

  const jsonContent = JSON.stringify(exportData, null, 2);
  const blob = new Blob([jsonContent], { type: 'application/json;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `clients_export_${new Date().toISOString().split('T')[0]}.json`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Helper function to escape CSV values
const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  // If value contains comma, quote, or newline, wrap in quotes and escape quotes
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};
